import $ from 'jquery';
import trigger from 'lib/analytics/trigger';
import contextGet from './context.get';
import combineBlocks from './combineBlocks';
import blocks from './blocks/index';

export default function anPageLoadOverall(scope) {
  var $scope = $(scope);
  var localBlocks = Array.prototype.slice.call(arguments); // turn args into legit Arr
  localBlocks.shift(); // remove scope

  trigger('aa-pageload', [
    contextGet($scope),
    combineBlocks(localBlocks, blocks.globalBlock()) // any blocks that come WITH a pageLoad must win over its context
  ]);
}
